export default key => {
  if (!key) return '';
  if (key.length === 9) return `***-**-${key.slice(-4)}`;
  return key;
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/convertSsnKey.js